import SectionColumns from './SectionColumns';
export default SectionColumns;
